export default class paymentHelper {
  static disabled (paymentData) {
    return paymentData.refund_status === 'disabled' || !paymentData.tr
  }

  static canVoid (paymentData) {
    return (
      !this.disabled(paymentData) &&
      paymentData.tr.auth_void &&
      paymentData.tr.status === '4' &&
      !paymentData.child &&
      (paymentData.tr.payment_method === 'fa' ||
        paymentData.tr.payment_method === 'fa_test' ||
        paymentData.tr.payment_method === 'cc' ||
        paymentData.tr.payment_method === 'test' ||
          paymentData.tr.payment_method === 'apple' ||
          paymentData.tr.payment_method === 'mastercard-scof-token')
    )
  }

  static canRefund (paymentData) {
    return (
      !this.disabled(paymentData) &&
      paymentData.refund_status === 'refund_enabled' &&
      paymentData.refund === true &&
      paymentData.tr.status === '1' &&
      paymentData.tr.auth_refund === true &&
      paymentData.tr.auth_partial_refund_transaction === true
    )
  }

  static canComplete (paymentData) {
    const result = (
        !this.disabled(paymentData) &&
        paymentData.tr.auth_complete &&
        paymentData.tr.status === '4' &&
        !paymentData.child &&
        (paymentData.tr.payment_method === 'cc' ||
            paymentData.tr.payment_method === 'test' ||
            paymentData.tr.payment_method === 'apple' ||
            paymentData.tr.payment_method === 'mastercard-scof-token')
    )

    if (result) {
      console.log('✅ canComplete TRUE for:', paymentData)
    } else {
      console.log('❌ canComplete FALSE for:', paymentData)
    }

    return result
  }

  static canNotify (paymentData) {
    return (
      !this.disabled(paymentData) &&
      paymentData.tr.auth_send_notify &&
      (paymentData.tr.payment_method === 'cc' ||
        paymentData.tr.payment_method === 'test' ||
          paymentData.tr.payment_method === 'apple') &&
      (paymentData.tr.status === '4' || paymentData.tr.status === '1') &&
      paymentData.tr.parent_id === '0'
    )
  }
}
